import { icon } from './icons.js';
import type { Section } from '../router.js';

const TITLES: Record<Section, string> = {
  conversar: 'ASIS',
  espacio: 'Espacio',
  hoy: 'Hoy',
  escaneo: 'Escaneo de bienestar',
  personas: 'Personas',
  grupos: 'Grupos',
  conocimiento: 'Conocimiento',
  conectores: 'Conectores',
  modelos: 'Modelos',
  dispositivos: 'Dispositivos',
  redes: 'Redes Wi-Fi',
  memoria: 'Memoria',
  actividad: 'Actividad',
  perfil: 'Mi cuenta',
  ajustes: 'Ajustes',
  login: 'Iniciar sesión',
  setup: 'Configurar cuenta',
};

const SUBTITLES: Partial<Record<Section, string>> = {
  conversar: 'Una conversación, a tu ritmo.',
  hoy: 'Tu día, con un poco de ayuda.',
  escaneo: 'Pulso, respiración y voz, estimados por tu ASIS.',
  personas: 'Las personas importantes para ti. Añadirlas no les da acceso a tu cuenta.',
  grupos: 'Espacios compartidos entre cuentas de ASIS.',
  conocimiento: 'Lo que ASIS sabe de cada persona o grupo. Edítalo, bórralo o pregunta sobre ello.',
  conectores: 'Tus herramientas, al alcance de una conversación.',
  modelos: 'Elige cómo responde ASIS en cada tarea.',
  dispositivos: 'Tu ASIS, cerca de ti.',
  redes: 'Guarda tus redes una vez y envíalas a tus aparatos sin volver a teclear la contraseña.',
  memoria: 'Lo que quieres que ASIS recuerde de ti.',
  actividad: 'Vuelve a tus conversaciones.',
  perfil: 'Tu correo, nombre visible y sesión actual.',
  ajustes: 'Haz que ASIS funcione a tu manera.',
};

export function renderHeader(section: Section, opts: { userLabel?: string | null; subtitle?: string; right?: HTMLElement } = {}): HTMLElement {
  const header = document.createElement('header');
  header.className = 'topbar';
  const title = document.createElement('div');
  title.className = 'topbar-title';
  const h1 = document.createElement('h1');
  h1.textContent = TITLES[section] ?? section;
  title.append(h1);
  const sub = opts.subtitle ?? SUBTITLES[section];
  if (sub) {
    const p = document.createElement('p');
    p.className = 'topbar-sub';
    p.textContent = sub;
    title.append(p);
  }
  const right = document.createElement('div');
  right.className = 'topbar-right';
  if (opts.userLabel) {
    const badge = document.createElement('span');
    badge.className = 'badge';
    badge.textContent = opts.userLabel;
    right.append(badge);
  }
  if (opts.right) right.append(opts.right);
  header.append(title, right);
  return header;
}
